<template>
  <div style="position: relative;">
    <EligibilityGuideCard
      v-for="guide of peEligibilityAssistant.eligibilityGuides"
      :key="makeKey('guide',guide.id)"
      :item="guide"
      class="mb-4"
    />

    <!-- Claims -->
    <ClaimsCard
      v-for="claim of peEligibilityAssistant.claims"
      :key="makeKey('claim',claim.id)"
      :item="claim"
      class="mb-4"
    />

    <SectionAdderLine
      section="Claim"
      :has-new-section="peClaimsCardHasNewSection"
      @on-add="peClaimsCardAddSection"
    />

    <!-- Previous Denials -->
    <PreviousDenialsCard
      v-for="previousDenial of peEligibilityAssistant.previousDenials"
      :key="makeKey('previousDenial',previousDenial.id)"
      :item="previousDenial"
      class="mb-4"
    />

    <SectionAdderLine
      section="Previous Denial"
      :has-new-section="pePreviousDenialsCardHasNewSection"
      @on-add="pePreviousDenialsCardAddSection"
    />

    <!-- Persecutor Analysis -->
    <PersecutorAnalysisCard
      v-for="persecutorAnalysis of peEligibilityAssistant.persecutorAnalysis"
      :key="makeKey('persecutorAnalysis',persecutorAnalysis.id)"
      :item="persecutorAnalysis"
      class="mb-4"
    />

    <SectionAdderLine
      section="Persecutor Analysis"
      :has-new-section="pePersecutorAnalysisCardHasNewSection"
      @on-add="pePersecutorAnalysisCardAddSection"
    />

    <OneYearFilingDeadlinesCard
      v-for="oneYearFilingDeadline of peEligibilityAssistant.oneYearFilingDeadlines"
      :key="makeKey('oneYearFilingDeadline',oneYearFilingDeadline.id)"
      :item="oneYearFilingDeadline"
      class="mb-4"
    />

    <SectionAdderLine
      section="One Year Filing Deadline"
      :has-new-section="peOneYearFilingDeadlinesCardHasNewSection"
      @on-add="peOneYearFilingDeadlinesCardAddSection"
    />

    <FirmResettlementsCard
      v-for="firmResettlement of peEligibilityAssistant.firmResettlements"
      :key="makeKey('firmResettlement',firmResettlement.id)"
      :item="firmResettlement"
      class="mb-4"
    />

    <SectionAdderLine
      section="Firm Resettlement"
      :has-new-section="peFirmResettlementsCardHasNewSection"
      @on-add="peFirmResettlementsCardAddSection"
    />

    <SafeThirdCountriesCard
      v-for="safeThirdCountry of peEligibilityAssistant.safeThirdCountries"
      :key="makeKey('safeThirdCountry',safeThirdCountry.id)"
      :item="safeThirdCountry"
      class="mb-4"
    />

    <SectionAdderLine
      section="Safe Third Country"
      :has-new-section="peSafeThirdCountriesCardHasNewSection"
      @on-add="peSafeThirdCountriesCardAddSection"
    />

    <NationalSecuritiesCard
      v-for="nationalSecurities of peEligibilityAssistant.nationalSecurities"
      :key="makeKey('nationalSecurities',nationalSecurities.id)"
      :item="nationalSecurities"
      class="mb-4"
    />

    <SectionAdderLine
      section="National Security"
      :has-new-section="peNationalSecuritiesCardHasNewSection"
      @on-add="peNationalSecuritiesCardAddSection"
    />

    <CrimesCard
      v-for="crime of peEligibilityAssistant.crimes"
      :key="makeKey('crime',crime.id)"
      :item="crime"
      class="mb-4"
    />

    <SectionAdderLine
      section="Crime"
      :has-new-section="peCrimesCardHasNewSection"
      @on-add="peCrimesCardAddSection"
    />

    <DeclarationCard
      v-for="declaration of peEligibilityAssistant.declarations"
      :key="makeKey('declaration',declaration.id)"
      :item="declaration"
      class="mb-4"
    />

    <SectionAdderLine
      section="Declaration"
      :has-new-section="peDeclarationsCardHasNewSection"
      @on-add="peDeclarationCardAddSection"
    />

    <v-overlay
      absolute
      :value="!canView"
      :class="{'party-overlay': !canView}"
      class="align-start"
    >
      <v-row
        align="start"
        justify="center"
      >
        <v-col
          cols="12"
          class="text-center"
        >
          <h2>You do not have permissions to view this section.</h2>
        </v-col>
      </v-row>
    </v-overlay>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import Actions from '@/data/Permissions/enums.json'
import { alertHandler } from '@/alertHandler'

import { PARTY_NAMESPACE } from '@/store/party'
import { USER_NAMESPACE } from '@/store/user'

import ClaimsCard from './SectionCards/AsylumAssistant/ClaimsCard.vue'
import CrimesCard from './SectionCards/AsylumAssistant/CrimesCard.vue'
import DeclarationCard from './SectionCards/AsylumAssistant/DeclarationCard.vue'
import EligibilityGuideCard from './SectionCards/AsylumAssistant/EligibilityGuideCard.vue'
import FirmResettlementsCard from './SectionCards/AsylumAssistant/FirmResettlementsCard.vue'
import NationalSecuritiesCard from './SectionCards/AsylumAssistant/NationalSecuritiesCard.vue'
import OneYearFilingDeadlinesCard from './SectionCards/AsylumAssistant/OneYearFilingDeadlinesCard.vue'
import PersecutorAnalysisCard from './SectionCards/AsylumAssistant/PersecutorAnalysisCard.vue'
import PreviousDenialsCard from './SectionCards/AsylumAssistant/PreviousDenialsCard.vue'
import SafeThirdCountriesCard from './SectionCards/AsylumAssistant/SafeThirdCountriesCard.vue'
import SectionAdderLine from './SectionTools/SectionAdderLine.vue'

export default {
  name: 'PEAsylumAssistant',

  components: {
    ClaimsCard,
    CrimesCard,
    DeclarationCard,
    EligibilityGuideCard,
    FirmResettlementsCard,
    NationalSecuritiesCard,
    OneYearFilingDeadlinesCard,
    PersecutorAnalysisCard,
    PreviousDenialsCard,
    SafeThirdCountriesCard,
    SectionAdderLine,
  },

  beforeRouteLeave (_, __, next) {
    if (this.peAnyUnlockedSections) {
      const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
      if (answer) {
        this.peLockPartySections()
        next()
      } else next(false)
    } else {
      this.peLockPartySections()
      next()
    }
  },

  props: {
    id: {
      type: String || Number,
      required: true,
    },
  },

  setup () {
    return { ...alertHandler() }
  },

  data () {
    return {
      canView: true,
    }
  },

  computed: {
    peDeclarationsCardHasNewSection () {
      return this.peEligibilityAssistant?.declarations?.length > 0
    },

    userCan () {
      return {
        viewSection: this.can(Actions.Platform.PartyEdit.Sections.AsylumAssistant.View),
      }
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peAnyUnlockedSections',
      'peClaimsCardHasNewSection',
      'peCrimesCardHasNewSection',
      'peEligibilityAssistant',
      'peFirmResettlementsCardHasNewSection',
      'peNationalSecuritiesCardHasNewSection',
      'peOneYearFilingDeadlinesCardHasNewSection',
      'pePersecutorAnalysisCardHasNewSection',
      'pePreviousDenialsCardHasNewSection',
      'peSafeThirdCountriesCardHasNewSection',
    ]),

    ...mapGetters(USER_NAMESPACE, [
      'can',
    ]),
  },

  async created () {
    if (!this.userCan.viewSection) {
      this.canView = false
      this.displayAlert('error', 'You do not have permissions to view this section.')
      return
    }

    await this.peGetSelectedPartySection({ id: this.id, section: 'asylum_assistant' }).
      catch(e => {
        if (e.status === 403) this.$router.push({ name: 'resourceAccessDenied', query: { party_id: this.id } })
        else if (e.status === 404) this.$router.push({ name: 'resourceNotFound' })
        else this.displayAlert('error', `An unexpected error occurred: ${e.message}`)
      })

    await this.peInitAsylumAssistantSection().
      catch(_ => this.displayAlert('error', 'Error Loading Asylum Assistant Cards'))
  },

  methods: {
    makeKey (section, index) { return `${section}#${index}` },

    ...mapActions(PARTY_NAMESPACE, [
      'peClaimsCardAddSection',
      'peCrimesCardAddSection',
      'peDeclarationCardAddSection',
      'peFirmResettlementsCardAddSection',
      'peGetSelectedPartySection',
      'peInitAsylumAssistantSection',
      'peLockPartySections',
      'peNationalSecuritiesCardAddSection',
      'peOneYearFilingDeadlinesCardAddSection',
      'pePersecutorAnalysisCardAddSection',
      'pePreviousDenialsCardAddSection',
      'peSafeThirdCountriesCardAddSection',
    ]),
  },
}
</script>

<style scoped>
.party-overlay {
  margin-top: -75px;
  padding-top: 50vh;
  z-index: 10;
  backdrop-filter: blur(6px);
}
</style>
